import { render, staticRenderFns } from "./RadioBoxInput.vue?vue&type=template&id=e6a22cbc&scoped=true"
import script from "./RadioBoxInput.vue?vue&type=script&lang=js"
export * from "./RadioBoxInput.vue?vue&type=script&lang=js"
import style0 from "./RadioBoxInput.vue?vue&type=style&index=0&id=e6a22cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a22cbc",
  null
  
)

export default component.exports